import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ReconciliationReportDatUtility } from "../../../utilities/reconciliation-report-data.utility";
import { ReconciliationReportFilteringUtility } from "../../../utilities/reconciliation-report-filtering.utility";
import { FormControl } from "@angular/forms";
import { AfterViewInit } from "@angular/core";

@Component({
  selector: "app-net-cash-table",
  templateUrl: "./net-cash-table.component.html",
  styleUrls: ["./net-cash-table.component.scss"],
})
export class NetCashTableComponent implements OnInit, AfterViewInit {
  @Input() data: any[] = [];
  @Input() dataUtility: ReconciliationReportDatUtility;
  @Input() filteringUtility: ReconciliationReportFilteringUtility;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public tableData: MatTableDataSource<any>;
  public displayedColumns: string[] = ["location", "thirdParty"];

  public filter3pdsControl = new FormControl([]);
  public filterLocationsControl = new FormControl([]);
  constructor(private dialog: MatDialog) {}
  ngOnInit(): void {
    const dspColumns = [
      "dspGrossSales",
      "errorCharges",
      "dspTaxToRestaurant",
      "nonPromoFees",
      "promoFees",
      "dspAdjustments",
      "dspTotalCash",
    ];
    if (this.dataUtility.existingReport.includePosInRec) {
      this.displayedColumns.push(
        ...[
          "posSales",
          "posTax",
          "posAdjustments",
          "posTotalCash",
          ...dspColumns,
          "cashVariance",
        ]
      );
    } else {
      this.displayedColumns.push(
        ...[
          "dspGrossSales",
          "dspTips",
          "errorCharges",
          "dspTaxToRestaurant",
          "nonPromoFees",
          "promoFees",
          "dspAdjustments",
          "dspTotalCash",
        ]
      );
    }
    this.tableData = new MatTableDataSource(this.data);
  }
  ngAfterViewInit(): void {
    this.tableData.paginator = this.paginator;
    this.tableData.sort = this.sort;
    this.filteringUtility.set3pdAndLocationFilterPredicate(
      this.tableData,
      this.filter3pdsControl,
      this.filterLocationsControl
    );
  }
}
